import styled from "@emotion/styled";

export const Container = styled.div`
  width: 280px;
`;

export const Cover = styled.div`
  min-width: 280px;
  min-height: 280px;
  background-color: white;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-image: url(${(props) => props.img});
  background-size: cover;
  background-position: center;
  cursor: pointer;

  &:hover > span {
    background-color: #00000015;
  }

  &:hover > div {
    transform: scale(1.05);
    opacity: 1;
  }
`;

export const CoverImg = styled.span`
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 20px;
  position: absolute;
  background-color: #00000000;
  top: 0;
  left: 0;
  transition: 0.5s;
`;

export const PlayButton = styled.div`
  width: 65px;
  height: 45px;
  background-color: #114c97;
  color: white;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  transition: 0.25s;
  opacity: 0;
`;

export const Anchor = styled.div`
  display: flex;
  opacity: 0;
  align-items: center;
  gap: 10px;
  background-color: #ffcc00;
  width: max-content;
  padding: 5px 20px;
  border-radius: 5px;
  text-decoration: none;
  font-family: sans-serif;
  color: #114c97;
  margin-top: 15px;
  transition: 0.25s;
`;
